import { securityRequest } from '@/utils/request'

export const queryConfigV2 = params => securityRequest.get('/security/configV2/listForOperator', { params })
export const saveConfigV2 = data => securityRequest.post('/security/configV2/save', { data })

export const queryConfigHistory = params => securityRequest.get('/security/configHistory/pageList', { params })

// 获取配置处理进度
export const getConfigChangeHandleProgress = params =>
    securityRequest.get('/security/configV2/getConfigChangeHandleProgress', { params })

// 获取配置缓存
export const getConfigCache = params => securityRequest.get('/security/configV2/find', { params })
